import styled, { css } from 'styled-components';
import { FuelIcon } from '@frete.com/fuel-react';
import { mediasQuery } from '@utils/responsive';

const HEIGHT_MOBILE_MENU = '66px';

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    flex-direction: column;
    ${mediasQuery.minMdMin} {
      justify-content: center;
      min-height: calc(100vh - 240px);
    }

    ${mediasQuery.maxMdMax} {
      margin-top: ${theme.spacing.km6};
      padding-bottom: calc(96px + ${HEIGHT_MOBILE_MENU});
    }
  `}
`;

export const WrapperCardList = styled.ul`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.km12};
    display: grid;
    gap: ${theme.spacing.km6};
    align-items: center;
    width: 100%;
    grid-template-columns: 2fr auto 2fr auto 2fr;
    max-width: 1182px;
    list-style: none;

    ${mediasQuery.maxMdMax} {
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing.km4};
    }
  `}
`;

export const ArrowIcon = styled(FuelIcon)`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    color: ${theme.color.icon.neutral.weak};

    ${mediasQuery.maxMdMax} {
      transform: rotate(90deg);
    }
  `}
`;

export const WrapperButton = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.km12};
    display: flex;
    gap: ${theme.spacing.km5};
    align-items: center;
    justify-content: center;
    width: 180px;

    ${mediasQuery.maxMdMin} {
      box-shadow: ${theme.elevation.ton8};
      position: fixed;
      width: 100%;
      background-color: ${theme.color.background.neutral.default};
      bottom: ${HEIGHT_MOBILE_MENU};
      padding: ${theme.spacing.km6};
    }
  `}
`;
